// 需求2265 小部件广告修改底部锚定adx广告修改成顶部锚定广告 // 需求2307 将小米天气，小部件广告顶部锚定adx广告修改底部锚定广告
export const top_cnchor_domains = ["en-miwg.comfortweather.com", "en-wg.comfortweather.com", "mos.comfortweather.com"];
// 多科俄罗斯版

// nothing测试域名
// export const appnothingWeatherDomains = ["en-nothing.comfortweather.com"];

export const domainConfig: any = {
  "24hweather.com": "https://www.24hweather.com",
  "test.comfortweather.com": "https://test.comfortweather.com",
  "test1.comfortweather.com": "https://test1.comfortweather.com",
  "mobi321.com": "https://wx.mobi321.com",
  default: "https://www.comfortweather.com",
};

export const tranDomains = ["tr-tab.comfortweather.com"];
export const miQsWeatherDomains = ["m-qs.comfortweather.com"];
